import {
  CHNL_ADMIN_ROLE,
  DEPT_ADMIN_ROLE,
  GBL_CHNL_ADMIN_ROLE,
  ORG_ADMIN_ROLE,
  SYS_ADMIN_ROLE,
  AUDITOR_ROLE,
  RECSHARE_ADMIN_ROLE,
} from "../appConfig";

export default [
  {
    _name: "CSidebarNav",
    _children: [
      {
        _name: "CSidebarNavTitle",
        _children: ["全域"],
        roles: [SYS_ADMIN_ROLE],
      },
      {
        _name: "CSidebarNavItem",
        name: "單位管理",
        to: "/global/orgs",
        icon: "cil-library-building",
        roles: [SYS_ADMIN_ROLE],
      },
      {
        _name: "CSidebarNavItem",
        name: "全域頻道管理",
        to: "/global/channels",
        icon: "cib-apple-podcasts",
        roles: [SYS_ADMIN_ROLE],
      },
      {
        _name: "CSidebarNavItem",
        name: "帳號管理",
        to: "/global/users",
        icon: "cil-lock-locked",
        roles: [SYS_ADMIN_ROLE],
      },
      {
        _name: "CSidebarNavItem",
        name: "重設密碼",
        to: "/global/resetPwd",
        icon: "cil-lock-locked",
        roles: [SYS_ADMIN_ROLE],
      },
      {
        _name: "CSidebarNavTitle",
        _children: ["全域頻道"],
        roles: [GBL_CHNL_ADMIN_ROLE],
      },
      {
        _name: "CSidebarNavItem",
        name: "頻道管理",
        to: "/gbl-chnl/assets",
        icon: "cib-apple-podcasts",
        roles: [GBL_CHNL_ADMIN_ROLE],
      },
      {
        _name: "CSidebarNavItem",
        name: "單位白名單管理",
        to: "/gbl-chnl/whitelist",
        icon: "cil-book",
        roles: [GBL_CHNL_ADMIN_ROLE],
      },

      {
        _name: "CSidebarNavTitle",
        _children: ["單位"],
        icon: "cil-library-building",
        roles: [ORG_ADMIN_ROLE, AUDITOR_ROLE],
      },
      {
        _name: "CSidebarNavItem",
        name: "部門管理",
        to: "/org/depts",
        icon: "cil-library-building",
        roles: [ORG_ADMIN_ROLE],
      },
      {
        _name: "CSidebarNavItem",
        name: "人員管理",
        to: "/org/members",
        icon: "cil-user",
        roles: [ORG_ADMIN_ROLE],
      },
      {
        _name: "CSidebarNavItem",
        name: "帳號管理",
        to: "/org/users",
        icon: "cil-lock-locked",
        roles: [ORG_ADMIN_ROLE],
      },
      {
        _name: "CSidebarNavItem",
        name: "頻道管理",
        to: "/org/channels",
        icon: "cib-apple-podcasts",
        roles: [ORG_ADMIN_ROLE],
      },
      {
        _name: "CSidebarNavItem",
        name: "外部頻道管理",
        to: "/org/extchnls",
        icon: "cil-fork",
        roles: [ORG_ADMIN_ROLE],
      },
      {
        _name: "CSidebarNavItem",
        name: "頻道分享",
        to: "/org/share-chnl",
        icon: "cil-fork",
        roles: [ORG_ADMIN_ROLE],
      },
      {
        _name: "CSidebarNavItem",
        name: "錄音流通管理",
        to: "/org/recshare",
        icon: "cil-library-building",
        roles: [ORG_ADMIN_ROLE],
      },
      {
        _name: "CSidebarNavItem",
        name: "音檔檢查員",
        to: "/org/audit",
        icon: "cil-lock-locked",
        roles: [AUDITOR_ROLE],
      },


      {
        _name: "CSidebarNavTitle",
        _children: ["錄音流通"],
        roles: [RECSHARE_ADMIN_ROLE],
      },
      {
        _name: "CSidebarNavItem",
        name: "錄音流通設定",
        to: "/recshare/setting",
        icon: "cil-library-building",
        roles: [RECSHARE_ADMIN_ROLE],
      },
      {
        _name: "CSidebarNavItem",
        name: "成員管理",
        to: "/recshare/members",
        icon: "cil-people",
        roles: [RECSHARE_ADMIN_ROLE],
      },
      {
        _name: "CSidebarNavItem",
        name: "內容管理",
        to: "/recshare/assets",
        icon: "cib-apple-podcasts",
        roles: [RECSHARE_ADMIN_ROLE],
      },
      {
        _name: "CSidebarNavItem",
        name: "流通審核",
        to: "/recshare/approve",
        icon: "cil-check",
        roles: [RECSHARE_ADMIN_ROLE],
      },

      {
        _name: "CSidebarNavTitle",
        _children: ["部門"],
        roles: [DEPT_ADMIN_ROLE],
      },
      {
        _name: "CSidebarNavItem",
        name: "最新音檔",
        to: "/dept/latest",
        icon: "cil-star",
        roles: [DEPT_ADMIN_ROLE],
      },
      {
        _name: "CSidebarNavItem",
        name: "成員管理",
        to: "/dept/members",
        icon: "cil-people",
        roles: [DEPT_ADMIN_ROLE],
      },
      {
        _name: "CSidebarNavItem",
        name: "群組管理",
        to: "/dept/groups",
        icon: "cil-group",
        roles: [DEPT_ADMIN_ROLE],
      },
      {
        _name: "CSidebarNavItem",
        name: "頻道瀏覽",
        to: "/dept/channels",
        icon: "cib-apple-podcasts",
        roles: [DEPT_ADMIN_ROLE],
      },
      {
        _name: "CSidebarNavItem",
        name: "訂閱審核",
        to: "/dept/approve",
        icon: "cil-check",
        roles: [DEPT_ADMIN_ROLE],
      },
      //{
      //_name: 'CSidebarNavItem',
      //name: '個人授權管理',
      //to: '/dept/grant',
      //icon: 'cil-book',
      //roles: [DEPT_ADMIN_ROLE],
      //},

      {
        _name: "CSidebarNavTitle",
        _children: ["頻道"],
        roles: [CHNL_ADMIN_ROLE],
      },
      {
        _name: "CSidebarNavItem",
        name: "頻道管理",
        to: "/chnl/assets",
        icon: "cib-apple-podcasts",
        roles: [CHNL_ADMIN_ROLE],
      },
      //{
      //_name: 'CSidebarNavItem',
      //name: '個人授權管理',
      //to: '/chnl/grant',
      //icon: 'cil-book',
      //roles: [CHNL_ADMIN_ROLE],
      //},
      {
        _name: "CSidebarNavItem",
        name: "部門白名單管理",
        to: "/chnl/whitelist",
        icon: "cil-calendar",
        roles: [CHNL_ADMIN_ROLE],
      },

      /*
      {
        _name: 'CSidebarNavTitle',
        _children: ['Original']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-speedometer',
        badge: {
          color: 'primary',
          text: 'NEW'
        }
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Theme']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Colors',
        to: '/theme/colors',
        icon: 'cil-drop',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Typography',
        to: '/theme/typography',
        icon: 'cil-pencil'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Components']
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Base',
        route: '/base',
        icon: 'cil-puzzle',
        items: [
          {
            name: 'Breadcrumbs',
            to: '/base/breadcrumbs'
          },
          {
            name: 'Cards',
            to: '/base/cards'
          },
          {
            name: 'Carousels',
            to: '/base/carousels'
          }, 
          {
            name: 'Collapses',
            to: '/base/collapses'
          },
          {
            name: 'Forms',
            to: '/base/forms'
          },
          {
            name: 'Jumbotrons',
            to: '/base/jumbotrons'
          },
          {
            name: 'List Groups',
            to: '/base/list-groups'
          },
          {
            name: 'Navs',
            to: '/base/navs'
          },
          {
            name: 'Navbars',
            to: '/base/navbars'
          },
          {
            name: 'Paginations',
            to: '/base/paginations'
          },
          {
            name: 'Popovers',
            to: '/base/popovers'
          },
          {
            name: 'Progress Bars',
            to: '/base/progress-bars'
          },
          {
            name: 'Switches',
            to: '/base/switches'
          },
          {
            name: 'Tables',
            to: '/base/tables'
          },
          {
            name: 'Tabs',
            to: '/base/tabs'
          },
          {
            name: 'Tooltips',
            to: '/base/tooltips'
          }
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Buttons',
        route: '/buttons',
        icon: 'cil-cursor',
        items: [
          {
            name: 'Buttons',
            to: '/buttons/standard-buttons'
          },
          {
            name: 'Button Dropdowns',
            to: '/buttons/dropdowns'
          },
          {
            name: 'Button Groups',
            to: '/buttons/button-groups'
          },
          {
            name: 'Brand Buttons',
            to: '/buttons/brand-buttons'
          }
        ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Charts',
        to: '/charts',
        icon: 'cil-chart-pie'
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Icons',
        route: '/icons',
        icon: 'cil-star',
        items: [
          {
            name: 'CoreUI Icons',
            to: '/icons/coreui-icons',
            badge: {
              color: 'info',
              text: 'NEW'
            }
          },
          {
            name: 'Brands',
            to: '/icons/brands'
          },
          {
            name: 'Flags',
            to: '/icons/flags'
          }
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Notifications',
        route: '/notifications',
        icon: 'cil-bell',
        items: [
          {
            name: 'Alerts',
            to: '/notifications/alerts'
          },
          {
            name: 'Badges',
            to: '/notifications/badges'
          },
          {
            name: 'Modals',
            to: '/notifications/modals'
          }
        ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Widgets',
        to: '/widgets',
        icon: 'cil-calculator',
        badge: {
          color: 'primary',
          text: 'NEW',
          shape: 'pill'
        }
      },
      {
        _name: 'CSidebarNavDivider',
        _class: 'm-2'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Extras']
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Pages',
        route: '/pages',
        icon: 'cil-star',
        items: [
          {
            name: 'Login',
            to: '/pages/login'
          },
          {
            name: 'Register',
            to: '/pages/register'
          },
          {
            name: 'Error 404',
            to: '/pages/404'
          },
          {
            name: 'Error 500',
            to: '/pages/500'
          }
        ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Download CoreUI',
        href: 'http://coreui.io/vue/',
        icon: { name: 'cil-cloud-download', class: 'text-white' },
        _class: 'bg-success text-white',
        target: '_blank'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Try CoreUI PRO',
        href: 'http://coreui.io/pro/vue/',
        icon: { name: 'cil-layers', class: 'text-white' },
        _class: 'bg-danger text-white',
        target: '_blank'
      }

      */
    ],
  },
];
